<template>
    <div>
        <a-alert v-if="errorMessage" type="error" :message="errorMessage" banner closable
            @close="errorMessage = null" />

        <!-- filter -->
        <ARow :gutter="[8, 8]">
            <ACol :xl="6" :md="8" :sm="12" :span="24">
                <AMonthPicker v-model:value="state.params.month" placeholder="Pilih Bulan" style="width:100%;"
                    value-format="YYYY-MM" format="MMMM YYYY" />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12" :span="24">
                <FilterWilayahSemuaMultiple style="width:100%;" :include-all="true"
                    v-model:value="state.params.wilayah_ids" placeholder="Pilih Wilayah" :level="1" />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12" :span="24">
                <AButton type="primary" title="cari" @click="fetchDataList" :loading="state.isFetching">
                    <span v-if="!state.isFetching" class="fa fa-search" aria-hidden="true" />
                    <span v-else>
                        Memuat Data ...
                    </span>
                </AButton>
            </ACol>
        </ARow>

        <!-- button action menu -->
        <div class="row justify-content-end mt-4" v-if="!state.isFetching">
            <div class="col-lg-6 col-md-12">
                <ASpace>
                    <ATooltip v-if="hasRoles([ROLE_ADMIN_BK, ROLE_CRM_HELPDESK_CUSTOMER_CARE])"
                        title="Validasi Target SFC. On untuk validasi SFC bersifat wajib pada Target Salesman. Off untuk melewati validasi SFC">
                        <ASpace>
                            <ASwitch v-model:checked="state.isRequired" @change="handleSwitchChange" />
                            <span>Validasi SFC</span>
                        </ASpace>
                    </ATooltip>
                </ASpace>
            </div>
            <div class="col-lg-6 col-md-12 text-right">
                <ASpace>
                    <ATooltip title="List Group Wilayah">
                        <AButton type="primary" @click="btnGroupWilayahList">
                            <i class="fa fa-list" aria-hidden="true" />
                        </AButton>
                    </ATooltip>
                    <ATooltip title="Upload Dokumen">
                        <AButton type="primary" @click="btnUpload">
                            <i class="fa fa-upload" aria-hidden="true"></i>
                        </AButton>
                    </ATooltip>
                    <ATooltip title="Tambahkan">
                        <AButton type="primary" @click="btnForm">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </AButton>
                    </ATooltip>
                    <ATooltip title="Download excel">
                        <DownloadExcel :url="state.endpoint.current" :params="queryParams()" @errors="errorMessage" />
                    </ATooltip>
                </ASpace>
            </div>
        </div>

        <!-- list table -->
        <div class="table-responsive text-nowrap mt-4">
            <MdTable :columns="state.columns" :data-source="state.data" size="small"
                :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" :pagination="{
                    showSizeChanger: true,
                    pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
                    showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
                    total: state.meta.total,
                    pageSize: state.meta.per_page,
                    current: state.meta.page,
                }" @change="handleTableChange" :loading="state.isFetching">

                <template #wilayah_name="{ record }">
                    <span>
                        {{
                            record.level_wilayah === 0
                                ? '-'
                                : record.level_wilayah === 2
                                    ? `${record.entitas_name || '-'} (${record.wilayah_name || '-'})`
                                    : (record.wilayah_name || '-')
                        }}
                    </span>
                </template>

                <template #no="{ index }">
                    <span>
                        {{ (state.meta.page - 1) * state.meta.per_page + 1 + index }}
                    </span>
                </template>

                <template #level_wilayah="{ record }">
                    <span>
                        {{
                            record.level_wilayah === 0 ? 'All Area' :
                                record.level_wilayah === 1 ? 'Provinsi' :
                                    record.level_wilayah === 2 ? 'Group Wilayah' :
                                        '-'
                        }}
                    </span>
                </template>

                <template #action="{ record }">
                    <ASpace>
                        <!-- <ATooltip
                            title="List Level Target">
                            <AButton
                                class="button"
                                size="small"
                                @click="btnLevelTargetList(record)">
                                <i class="fa fa-list" />
                            </AButton>
                        </ATooltip> -->
                        <ATooltip title="Edit">
                            <AButton class="button" size="small" @click="btnForm(record)">
                                <i class="fe fe-edit" />
                            </AButton>
                        </ATooltip>
                        <ATooltip
                            v-if="hasRoles([ROLE_TSO, ROLE_ADMIN_BK, ROLE_TIM_CRM, ROLE_CRM_HELPDESK_CUSTOMER_CARE])"
                            title="Hapus">
                            <AButton class="button" size="small" :loading="record.isDelete" @click="btnDelete(record)">
                                <i class="fe fe-trash" />
                            </AButton>
                        </ATooltip>
                    </ASpace>
                </template>
            </MdTable>
        </div>

        <!-- form -->
        <Form v-if="visibleFormModal" v-model:visible="visibleFormModal" v-model:item="visibleFormItemModal"
            @success="fetchDataList" />

        <!-- upload -->
        <Upload v-if="visibleUploadModal" v-model:visible="visibleUploadModal" @success="fetchDataList" />

        <!-- detail -->
        <!-- <LevelTargetList
            v-if="visibleLevelTargetListModal"
            v-model:visible="visibleLevelTargetListModal"
            v-model:item="visibleLevelTargetListItemModal"/> -->

        <!-- detail -->
        <GroupWilayahList v-if="visibleGroupWilayahListModal" v-model:visible="visibleGroupWilayahListModal"
            v-model:item="visibleGroupWilayahListItemModal" @success="handleGroupWilayahSuccess" />
    </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, computed } from 'vue'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import Upload from './Upload'
import Form from './Form'
// import LevelTargetList from './LevelTargetList'
import GroupWilayahList from './GroupWilayahList'
import FilterWilayahSemuaMultiple from '@/components/filter/FilterWilayahSemuaMultiple'
import moment from 'moment'
import {
    hasRoles,
    ROLE_ADMIN_BK,
    ROLE_TSO,
    ROLE_TIM_CRM,
    ROLE_CRM_HELPDESK_CUSTOMER_CARE,
} from '@/helpers'
import {
    updateUrlWithQuery,
    extractQueryParams,
} from '@/helpers/queryparams'

export default defineComponent({
    components: {
        DownloadExcel,
        Form,
        Upload,
        GroupWilayahList,
        // LevelTargetList,
        FilterWilayahSemuaMultiple,
    },
    setup() {
        const errorMessage = ref()
        const state = reactive({
            columns: [
                {
                    title: 'No',
                    slots: { customRender: 'no' },
                },
                {
                    title: 'Bulan',
                    dataIndex: 'month',
                },
                {
                    title: 'Target Hari Kerja',
                    dataIndex: 'target_hari_kerja',
                },
                {
                    title: 'Target Visit',
                    dataIndex: 'target_visit',
                },
                // {
                //     title: 'Target Efektif Visit',
                //     dataIndex: 'target_efektif_visit',
                // },
                // {
                //     title: 'Target NOO',
                //     dataIndex: 'target_noo',
                // },
                {
                    title: 'Level Wilayah',
                    dataIndex: 'level_wilayah',
                    slots: { customRender: 'level_wilayah' },
                },
                {
                    title: 'Wilayah',
                    dataIndex: 'wilayah_name',
                    slots: { customRender: 'wilayah_name' },
                },
                {
                    title: 'Tanggal Ditambahkan',
                    dataIndex: 'created_at',
                },
                {
                    title: 'Tanggal Update',
                    dataIndex: 'updated_at',
                },
                {
                    title: 'Action',
                    dataIndex: 'action',
                    slots: { customRender: 'action' },
                },
            ],
            endpoint: {
                current: '/api/atsalesman/salesman-target-sfc',
            },
            data: [],
            meta: {
                per_page: 10,
                page: 1,
                total: 0,
            },
            isFetching: false,
            params: extractQueryParams({
                q: '',
                month: null,
                wilayah_ids: [],
                page: 1,
                "per-page": 10,
            }),
            isRequired: true,
        })

        const handleTableChange = (page, filters, sorter) => {
            state.params.page = page.current
            state.params["per-page"] = page.pageSize

            fetchDataList()
        }

        const handleGroupWilayahSuccess = () => {
            fetchDataList()
        }

        const queryParams = () => {
            let params = state.params

            return updateUrlWithQuery(params)
        }

        // fetch list data
        const fetchDataList = () => {
            state.isFetching = true

            apiClient
                .get(state.endpoint.current, {
                    params: queryParams(),
                })
                .then(({ data }) => {
                    const { items, _meta } = data

                    state.data = items
                    state.meta.page = _meta.currentPage
                    state.meta.per_page = _meta.perPage
                    state.meta.total = _meta.totalCount
                })
                .finally(() => {
                    state.isFetching = false
                })
        }

        const fetchTargetSfcRequired = () => {
            apiClient
                .get('/api/atsalesman/target-sfc-required')
                .then(({ data }) => {
                    state.isRequired = (data ? true : false)
                })
                .finally(() => { })
        }

        const handleSwitchChange = (checked) => {

            let is_required = (checked ? 'true' : 'false')

            console.log("Set Value >> " + is_required)

            apiClient
                .post('/api/atsalesman/target-sfc-required/set', {
                    is_required: is_required,
                })
                .then(({ data }) => {
                    message.success(data.message)
                })
                .catch((err) => {
                    message.error("Gagal : " + err)
                })
        }

        // handle form
        const visibleFormModal = ref(false);
        const visibleFormItemModal = ref(null);

        const btnForm = (item = null, readOnly = false) => {
            console.log(item)
            visibleFormModal.value = true
            visibleFormItemModal.value = {
                ...item,
                readOnly,
            }
        }

        // handle upload
        const visibleUploadModal = ref(false);

        const btnUpload = () => {
            visibleUploadModal.value = true
        }

        // handle Group Wilayah
        const visibleGroupWilayahListModal = ref(false);
        const visibleGroupWilayahListItemModal = ref(null);

        const btnGroupWilayahList = (item = null) => {
            visibleGroupWilayahListModal.value = true
            visibleGroupWilayahListItemModal.value = item
        }

        // handle distributor list
        const visibleLevelTargetListModal = ref(false);
        const visibleLevelTargetListItemModal = ref(null);

        const btnLevelTargetList = (item = null) => {
            visibleLevelTargetListModal.value = true
            visibleLevelTargetListItemModal.value = item
        }

        const btnDelete = (record) => {
            Modal.confirm({
                title: 'Konfirmasi',
                content: `Yakin hapus data bulan ${record.month} ${record.level_wilayah === 0 || !record.wilayah_name
                        ? '(All Area)'
                        : `(Wilayah ${record.wilayah_name})`
                    }?`,
                okText: 'Ya',
                cancelText: 'Batal',
                onOk() {
                    record.isDelete = true

                    apiClient
                        .delete(`${state.endpoint.current}/wilayah`, {
                            data: {
                                month: record.month,
                                level_wilayah: record.level_wilayah,
                                wilayah_id: record.level_wilayah === 0
                                    ? null
                                    : record.level_wilayah === 2
                                        ? record.entitas
                                        : record.wilayah_id,
                            },
                        })
                        .then(({ data }) => {
                            message.success(data.message || 'Berhasil dihapus')
                            fetchDataList()
                        })
                        .catch((err) => {
                            message.error(err?.response?.data?.message || 'Gagal hapus')
                        })
                        .finally(() => {
                            record.isDelete = false
                        })
                },
            })
        }

        // handle vue
        onMounted(() => {
            fetchDataList()
            fetchTargetSfcRequired()
        })

        return {
            visibleFormModal,
            visibleFormItemModal,
            btnForm, // create or update
            fetchDataList,
            fetchTargetSfcRequired,
            state,
            handleTableChange,
            handleSwitchChange,
            handleGroupWilayahSuccess,
            errorMessage,
            visibleUploadModal,
            btnUpload,
            queryParams,
            btnLevelTargetList,
            btnDelete,
            visibleLevelTargetListModal,
            visibleLevelTargetListItemModal,
            btnGroupWilayahList,
            visibleGroupWilayahListModal,
            visibleGroupWilayahListItemModal,
            // only variable role
            hasRoles,
            ROLE_ADMIN_BK,
            ROLE_TSO,
            ROLE_TIM_CRM,
            ROLE_CRM_HELPDESK_CUSTOMER_CARE,
        }
    },
})
</script>